module.exports = __webpack_public_path__ + "static/discord-0780aa6f7f9d680d6282473caadec1f9.png";